// import React, { useEffect, useState } from 'react';
// import './Header.css'
// import { useMyContext } from "./MyProvider";

// const Header = ( ) => {
//     const { lang, setLang } = useMyContext();
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const handleLanguage = (e) => {
//     const selectedLang = e.target.value;
//     setLang(selectedLang);
//   };

//       const handleFontSizeChange = (size) => {
//     const elements = document.querySelectorAll("div");
//     elements.forEach((element) => {
//       const currentSize = parseInt(window.getComputedStyle(element).fontSize);
//       if (
//         (size === "increase" && currentSize <= 17) ||
//         (size === "decrease" && currentSize >= 12) ||
//         size === "ideal"
//       ) {
//         element.style.fontSize =
//           size === "increase"
//             ? `${currentSize + 1}px`
//             : size === "decrease"
//             ? `${currentSize - 1}px`
//             : "14px";
//       }
//     });
//   };

//   useEffect(() => {
//     fetch(`${process.env.REACT_APP_URL_HEADER}/demo/getHeader/${lang}`, {
//                 method: 'GET',
//                 headers: {
//           'Content-Type': 'application/json', 
//           'Accept': 'application/json'   ,   
//           "Access-Control-Allow-Headers" : "Content-Type",
//           "Access-Control-Allow-Origin": "*",
//           "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PATCH"
//         }
//               })

//    // Replace with your actual API endpoint
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then((data) => {
//         setData(data[0]); // Assuming the data is an array and we want the first item
//         setLoading(false);
//       })
//       .catch((error) => {
//         setError(error);
//         setLoading(false);
//       });
//   }, [lang]);

//   if (loading) {
//     return  <> <div className="wrapper row1">

//     <header id="header" className="full_width clear">
//     <br/>
//     <div style={{textAlign:'center'}}>


//     <div style={{ margin: '-6px -96px -24px -185px',float: 'left', paddingLeft: '0px', width: '25%'}}>
//     { }
//           { }
//           </div>


// <div  style={{ float: 'left', paddingLeft: '1px', width: '69%',textAlign:'left'}} >

// <h2>{ }</h2>
//       <h5>{ }</h5>
//       <h5>{}</h5></div> 

// </div>
// </header>
//     </div>

//     </>;
//   }

//   if (error) {

//     return  <> <div className="wrapper row1">

//     <header id="header" className="full_width clear">
//     <br/>
//     <div style={{textAlign:'center'}}>


//     <div style={{ margin: '-6px -96px -24px -185px',float: 'left', paddingLeft: '0px', width: '25%'}}>
//     { }
//           { }
//           </div>


// <div  style={{ float: 'left', paddingLeft: '1px', width: '69%',textAlign:'left'}} >

// <h2>{ }</h2>
//       <h5>{ }</h5>
//       <h5>{}</h5></div> 

// </div>
// </header>
//     </div>

//     </>;  }

//   return (
//     <>



// <div className="wrapper row1">

//           <div className="rightSideIcon" textAlign="right">

//         <select name="see_lang" id="see_lang" onChange={handleLanguage}>
//           <option value="1">Eng</option>
//           <option value="2">Hin</option>
//         </select>
//         <span onClick={() => handleFontSizeChange("increase")}>+A</span>
//         <span onClick={() => handleFontSizeChange("ideal")}>A</span>
//         <span onClick={() => handleFontSizeChange("decrease")}>-A</span>
//       </div>


//   <header id="header" className="header-container" style={{display:'flex',gap:'25px',justifyContent:'start'}}>
//     <div className="header-left"  >
//       {data?.left_image && (
//         <img src={`data:image/png;base64,${data.left_image}`} alt="Left" />
//       )}
//       {data?.left_image_1 && (
//         <img src={`data:image/png;base64,${data.left_image_1}`} alt="Left" />
//       )}
//     </div>

//     <div className="header-center">
//       <h2>{data?.heading_1}</h2>
//       <h5>{data?.heading_2}</h5>
//       <h5>{data?.heading_3}</h5>
//     </div>

//     <div className="header-right">
//      {data?.right_image && (
//       <img id="right_image" src={`data:image/jpeg;base64,${data.right_image}`} alt="PMGKAY" />
//     )}
//     {data?.right_image_1 && (
//       <img id="right_image_1" src={`data:image/jpeg;base64,${data.right_image_1}`} alt="State Logo" />
//     )}
//     </div>
//   </header>
//   <br/>
// </div>


//     </>
//   );
// };

// export default Header;


//===========================================================

import React from 'react';
import './Header.css';
import { useMyContext } from "./MyProvider";

// 👉 Import your static images
//import leftlm from '../assets/leftLogo.png';
// import rightLogo from '../assets/rightLogo.png';

import leftImg_1 from '../images/leftImg_1.png';
import leftImg_2 from '../images/leftImg_2.png';

const Header = () => {

  const { setLang } = useMyContext();

  // Language change
  const handleLanguage = (e) => {
    setLang(e.target.value);
  };

  // Font size control (restricted to header only)
  const handleFontSizeChange = (size) => {
    const elements = document.querySelectorAll(".header-container *");

    elements.forEach((element) => {
      const currentSize = parseInt(window.getComputedStyle(element).fontSize);

      if (
        (size === "increase" && currentSize <= 18) ||
        (size === "decrease" && currentSize >= 12) ||
        size === "ideal"
      ) {
        element.style.fontSize =
          size === "increase"
            ? `${currentSize + 1}px`
            : size === "decrease"
              ? `${currentSize - 1}px`
              : "14px";
      }
    });
  };

  return (
    <div className="wrapper row1">

      {/* <div className="rightSideIcon" textAlign="right">

          <select name="see_lang" id="see_lang" onChange={handleLanguage}>
           <option value="1">Eng</option>
           <option value="2">Hin</option>
         </select>
         <span onClick={() => handleFontSizeChange("increase")}>+A</span>
         <span onClick={() => handleFontSizeChange("ideal")}>A</span>
         <span onClick={() => handleFontSizeChange("decrease")}>-A</span>
       </div> */}

      <header id="header" className="header-container" style={{ display: 'flex', gap: '25px', justifyContent: 'start' }}>



        {/* images */}
        <div
          className="header-left"
          style={{ marginTop: "30px", marginBottom: "15px" }}
        >          <img src={leftImg_1} alt="Left Image" />
          <img src={leftImg_2} alt="Right Image" />
        </div>


        {/* STATIC HEADING */}
        <div className="header-center" style={{  marginTop: "30px", marginBottom: "15px"  }}   >
          <h2 >
            Scheme for Modernization And Reforms through Technology in Public Distribution System (SMART-PDS)
          </h2>
          <h5>Department of Public Distribution System</h5>
          <h5>Government of India</h5>
        </div>

      </header>
    </div>
  );
};

export default Header;